import { render, staticRenderFns } from "./SwitchConfig.vue?vue&type=template&id=ba7113c6"
import script from "./SwitchConfig.vue?vue&type=script&lang=js"
export * from "./SwitchConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports